import { ProjectConstantLocalKeys } from "@/constants/projects.constant";

interface ProjectSessionData {
  projectName?: string;
  clientName?: string;
  projectId?: string;
  customerId?: string;
  status?: string;
}

export const useProjectSession = (): {
  setProjectData: (data: ProjectSessionData) => void;
  getProjectData: () => ProjectSessionData;
  clearProjectData: () => void;
} => {
  const setProjectData = (data: ProjectSessionData): void => {
    sessionStorage.setItem(
      ProjectConstantLocalKeys.PROJECT_NAME,
      JSON.stringify(data),
    );
  };

  const getProjectData = (): ProjectSessionData => {
    const data = sessionStorage.getItem(ProjectConstantLocalKeys.PROJECT_NAME);

    return data ? JSON.parse(data) : {};
  };

  const clearProjectData = (): void => {
    sessionStorage.removeItem(ProjectConstantLocalKeys.PROJECT_NAME);
    sessionStorage.removeItem(ProjectConstantLocalKeys.CLIENT_NAME);
  };

  return {
    setProjectData,
    getProjectData,
    clearProjectData,
  };
};
